import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
/**
 * Provides an analytics context to supply attributes to events based on a URL
 */
export const LinkAnalyticsContext = ({
  display,
  id,
  children,
  source
}) => {
  const displayCategory = display === 'url' ? 'link' : undefined;
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      source,
      attributes: {
        displayCategory,
        display,
        id
      }
    }
  }, children);
};